// NSARA Stores V2 — utilitaires partagés par l'expérience boutiques
// (Mes boutiques, workspace boutique, vitrine publique).
//
// Rien ici ne calcule de donnée métier: ce ne sont que des formats d'affichage
// et des constructeurs d'URL. Les chiffres viennent toujours de l'API.

// "15 000 F CFA" — format prix utilisé dans le catalogue et la vitrine.
export const formatMoney = (value) => `${Number(value || 0).toLocaleString('fr-FR')} F CFA`;

// "325 000 F" — format compact utilisé sur les cartes de boutique.
export const formatMoneyShort = (value) => `${Number(value || 0).toLocaleString('fr-FR')} F`;

// Monogramme de repli quand la boutique n'a pas de logo (1 à 2 initiales).
export const shopMonogram = (name) => {
  const words = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '?';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return `${words[0].charAt(0)}${words[1].charAt(0)}`.toUpperCase();
};

const origin = () => (typeof window !== 'undefined' ? window.location.origin : '');

// Lien produit public individuel (existant depuis Product Core: /p/:publicId).
export const buildPublicProductUrl = (publicId, base) => `${base || origin()}/p/${publicId}`;

// NSARA Stores V2 — lien vitrine publique d'une boutique.
// Identifiant: le shopId (uuid) déjà présent en base, comme un produit utilise
// déjà son public_id (uuid). Aucun slug ni migration ajoutée.
export const buildPublicStoreUrl = (shopId, base) => `${base || origin()}/s/${shopId}`;

const sameDay = (a, b) => a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

// "Aujourd'hui · 15:42" / "Hier · 09:10" / "12/09/2026 · 09:10"
export const formatWhen = (iso) => {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  const now = new Date();
  const time = date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  const yesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
  if (sameDay(date, now)) return `Aujourd'hui · ${time}`;
  if (sameDay(date, yesterday)) return `Hier · ${time}`;
  return `${date.toLocaleDateString('fr-FR')} · ${time}`;
};

export const PRODUCT_FILTERS = [
  { id: 'all', label: 'Tous' },
  { id: 'online', label: 'En ligne' },
  { id: 'hidden', label: 'Masqués' },
  { id: 'low', label: 'Stock faible' }
];

export const isLowStock = (product) =>
  Number(product?.stock_quantity || 0) <= Number(product?.low_stock_threshold || 0);

// Filtre catalogue appliqué côté client sur une liste DÉJÀ filtrée par shopId
// côté serveur: il ne peut donc jamais faire apparaître le produit d'une autre
// boutique (voir backend/routes/products.js).
export const filterProducts = (products, filterId, query) => {
  const search = String(query || '').trim().toLowerCase();
  return (products || []).filter((product) => {
    if (filterId === 'online' && !product.public_enabled) return false;
    if (filterId === 'hidden' && product.public_enabled) return false;
    if (filterId === 'low' && !isLowStock(product)) return false;
    if (search && !String(product.name || '').toLowerCase().includes(search)) return false;
    return true;
  });
};

export const ORDER_TABS = [
  { id: '', label: 'Toutes' },
  { id: 'PENDING', label: 'Nouvelles' },
  { id: 'CONFIRMED', label: 'Confirmées' },
  { id: 'COMPLETED', label: 'Terminées' }
];

export const ORDER_STATUS_LABELS = {
  PENDING: 'Nouvelle',
  CONFIRMED: 'Confirmée',
  COMPLETED: 'Terminée',
  CANCELLED: 'Annulée'
};

// Accent marchand: presets fixes uniquement (pas de sélecteur de couleur
// arbitraire, pas de constructeur de thème — voir section 15 de la mission).
// Aucune colonne "couleur" n'existant en base, l'accent est dérivé de façon
// déterministe du nom de la boutique: stable, sans stockage, sans migration.
export const ACCENT_PRESETS = [
  { id: 'forest', label: 'Forêt', value: '#0F3B29' },
  { id: 'nsara', label: 'NSARA', value: '#1B6B4A' },
  { id: 'ink', label: 'Encre', value: '#14201B' },
  { id: 'clay', label: 'Argile', value: '#8A4B32' },
  { id: 'indigo', label: 'Indigo', value: '#2C3A6B' },
  { id: 'plum', label: 'Prune', value: '#5E3358' }
];

export const accentForShop = (shop) => {
  const key = String(shop?.name || '').trim().toLowerCase();
  if (!key) return ACCENT_PRESETS[1].value;
  let hash = 0;
  for (let i = 0; i < key.length; i += 1) hash = (hash * 31 + key.charCodeAt(i)) % 9973;
  return ACCENT_PRESETS[hash % ACCENT_PRESETS.length].value;
};
